// Arma el payload `tasks[]` que consume POST /orders/from-budget
// (generateOrderFromBudget) desde los items del SUMMARY del presupuesto
// (getBudgetSummary), NO desde el budgetitem crudo.
//
// Por qué el summary y no /get-items-budget: con el plan trazabilidad-equipos,
// los equipos asignados se guardan en el N:M `budgetitem_ascensor` (FK) y la
// columna legacy `elevator` queda NULL. El endpoint crudo no joinea el N:M, así
// que perdía los equipos y el backend rechazaba con "equipo obligatorio". El
// summary expone los equipos del N:M en `it.Ascensores` (+ deriva el string
// `elevator` para compat). Acá preferimos `id_ascensores` (FK canonical) y
// caemos a `elevator` string solo para items legacy sin N:M.
//
// @param {Array} items - items del summary (`summary.items`), cada uno con
//   `Ascensores: [{ id, nombre, position }]` y `elevator` (string|null).
// @returns {Array} tasks listas para generateOrderFromBudget.
export function buildApprovalOrderTasks(items) {
  return (items || []).map((it) => {
    const ids = (Array.isArray(it.Ascensores) ? it.Ascensores : [])
      .map((a) => a?.id)
      .filter((n) => typeof n === 'number');
    const elevator = typeof it.elevator === 'string' ? it.elevator.trim() : '';
    return {
      description: it.description || '',
      ...(ids.length > 0 ? { id_ascensores: ids } : { elevator }),
      cantidad: Number(it.quantity || 1),
      // BUG 3: propagar el hallazgo que el ítem resuelve (antes era `null` fijo →
      // la cascada de cierre nunca disparaba para ODTs creadas con "crear items").
      id_hallazgo: it.id_hallazgo ?? null,
      id_coleccion_item: it.id_coleccion_item ?? null,
    };
  });
}
